import dayjs from 'dayjs';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getToday() {
  return dayjs.utc().format('YYYY-MM-DD');
}
